module.exports = __webpack_public_path__ + "catalog/items/firesafety/Phone-Red/Phone-Red.svg";